import React, { useEffect, useState } from "react";
import { Card } from "primereact/card";
import { getUserData } from "../../utils/localStorage";
import { useNavigate } from "react-router-dom";

const MasterView = () => {

  const navigate = useNavigate();

  const { userProfileData } = getUserData();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [])

  return (
    <main id="main" className="main">
      <section className="section dashboard" >
        <div className="row">
          {/* Left side columns */}
          <div className="col-lg-12" >
            <div className="row">
              <div className=" col-md-12">
                <div className="card info-card sales-card" style={{ height: windowWidth > 1199 ? '80vh' : '120vh' }}>
                  <div className="card-body">
                    <div
                      style={{
                        alignItems: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <h5 className="card-title flex">
                        <div
                          className="mr-3 cursor-pointer"
                          onClick={() => navigate("/")}
                        >
                          <i class="bi bi-arrow-left-circle-fill"></i>
                        </div> Master's
                      </h5>

                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/type/list');
                          }}>
                          <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-person-circle"} />
                              <span style={{ color: "#1e439b", marginLeft:10 }}>
                                User Type
                              </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/Branch/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-person-video3"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  Branch
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/user/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-person"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Users
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>

                      
                    </div>
                    <div className="row">
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/role/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-person-vcard"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  User Role
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/bank/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-bank"}  />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Bank
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card   style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/Banker/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-bank"}   />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Banker
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>

                      
                    </div>

                    <div className="row">

                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/company/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-building"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  Company
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/CAUser/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-person-square"}  />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                CA User
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/product/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                                <i className={"bi bi-file-earmark-bar-graph"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Product
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      
                    </div>
                    <div className="row">
                      
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/business-partner/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-briefcase"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                Business Partner
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/lead-status/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-briefcase"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  Lead Status
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>

                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/bank-account/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-bank"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  Bank Account
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                     
                     
                    </div>
                    <div className="row">
                      
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/stateCities/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-briefcase"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  State & Cities
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/department-level/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-file-earmark-bar-graph"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  Department Level
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      {/*<div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/IVRExtension/list');
                          }}>
                            <div className="flex justify-content-between">
                              <h3 className="m-0">
                                <i className={"bi bi-file-earmark-bar-graph"} />
                                <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                  IVR Extension
                                </span>
                              </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>
                      <div className=" col-md-4">
                        <div className="card">
                          <Card style={{ color: "#ff5501", cursor: "pointer" }} onClick={() => {
                            navigate('/user-master/IVRExtensionUser/list');
                          }}>
                            <div className="flex justify-content-between">
                            <h3 className="m-0">
                              <i className={"bi bi-person-video3"} />
                              <span style={{ color: "#1e439b", marginLeft: 10 }}>
                                IVR Extension User
                              </span>
                            </h3>
                              <i className={"bi bi-arrow-right"} />
                            </div>
                          </Card>
                        </div>
                      </div>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default MasterView;
